<template>
  <v-treeview :items="conceptsTree" :open.sync="store.openConceptsPath" :active="activeNodes" activatable
    :load-children="loadChildren" transition dense :color="$vuetify.theme.themes.light.primary" item-key="UUID"
    multiple-active @update:active="(nodes) => updateActive(nodes)">
    <template v-slot:label="{ item, active }" style="cursor:pointer;">
      <template v-if="active">
        <template v-if="!storeConfiguration.isCurrentLoaded">{{ initCurrentConfiguration(item.configuration)
        }}</template>
        <template v-else-if="item.UUID === conceptClicked">{{ setCurrentConfiguration(item.configuration) }}</template>
      </template>

      <template v-if="store.conceptDetail.classType === item.id">{{ setCurrentProps(item.props) }}</template>

      <span v-bind:class="item.isIndividual ? 'no-select font-italic' : 'no-select'">
        {{ StoreConfiguration.getConfTreeNodeLabel(item.id, item.configuration, item.props) }}
      </span>
    </template>
  </v-treeview>
</template>

<script>
import ConceptsStore from "../concepts-store";
import StoreConfiguration from "../store-configuration";

export default {
  name: "ConceptsTree.vue",

  props: {
    conceptsTree: Array,
    activeConcepts: Array
  },

  data: () => ({
    store: ConceptsStore.state,
    StoreConfiguration: StoreConfiguration,
    storeConfiguration: StoreConfiguration.state,
    latestParent: null,
    conceptClicked: null,
    processUpdateActive: true,
    activeNodes: []
  }),

  beforeMount() {
    this.activeNodes = this.activeConcepts;
  },

  watch: {
    activeConcepts: function () {
      this.processUpdateActive = false;
      this.activeNodes = this.activeConcepts;
    }
  },

  methods: {
    /**
     * Update active nodes.
     *
     * @param activeNodes
     */
    updateActive: function (activeNodes) {

      // Do not continue statements in this function if active nodes are updated from watcher.
      if (!this.processUpdateActive) {
        this.processUpdateActive = true;
        return;
      }

      // Get the last active node.
      this.conceptClicked = activeNodes[activeNodes.length - 1];

      this.$emit('updateActive', this.conceptClicked)
    },

    /**
     * Init the current concept configuration as a global variable in order to access it through every component.
     * Case of concept in multi-path: the configuration of the first concept in the concept tree is taken into account.
     *
     * @param configuration
     */
    initCurrentConfiguration: function (configuration) {
      this.storeConfiguration.current = configuration;
      this.storeConfiguration.isCurrentLoaded = true;
    },

    /**
     * Set the current concept configuration as a global variable in order to access it through every component.
     *
     * @param configuration
     */
    setCurrentConfiguration: function (configuration) {
      this.storeConfiguration.current = configuration;
    },

    /**
     * Set the concept properties of the individual node selected.
     *
     * @param props
     */
    setCurrentProps: function (props) {
      this.store.individualParentProps = props;
    },

    /**
     * Emit an event to load children concepts and append them to the right concept node.
     */
    loadChildren: async function (item) {
      // Prevent to load children more than once.
      if (item.UUID !== this.latestParent) {
        this.latestParent = item.UUID;
        this.$emit('loadChildren', item);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-treeview-node__root.v-treeview-node--active {
  pointer-events: none;
}

::v-deep .v-treeview-node__toggle {
  pointer-events: all;
}
</style>